<div
    class="popup-view-container"
    tabindex="0"
    (click)="openMapItemDetails($event)"
    (keydown.enter)="openMapItemDetails($event)"
    (keydown.space)="openMapItemDetails($event)"
>
    <ng-content />
</div>
